import { useState, useRef, useEffect } from "react"
import { zoomLevels } from "../utils/settings"
import ZoomControl from "./ZoomControl"

const NavbarZoomControl = ({
    currentZoomIndex,
    onZoomChange,
    showLabel = true
}) => {
    const [isOpen, setIsOpen] = useState(false)
    const containerRef = useRef(null)

    // Close popup when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false)
            }
        }

        document.addEventListener("mousedown", handleClickOutside)
        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
        }
    }, [])

    const handleZoomIn = () => {
        if (currentZoomIndex > 0) {
            onZoomChange(zoomLevels[currentZoomIndex - 1])
        }
    }

    const handleZoomOut = () => {
        if (currentZoomIndex < zoomLevels.length - 1) {
            onZoomChange(zoomLevels[currentZoomIndex + 1])
        }
    }

    return (
        <div className="relative" ref={containerRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className={`flex items-center justify-center space-x-2 
          px-3 text-gray-700 hover:bg-gray-300 rounded
           py-1.5  
          hover:from-gray-200 hover:to-gray-300 
          transition-all duration-200 ${isOpen ? 'bg-gray-300' : ''}`}
                title="Zoom Kontrolü"
            >
                <span className="text-lg">±</span>
            </button>

            {isOpen && (
                <div className="absolute left-0 mt-3 z-[9999] bg-white rounded-lg shadow-xl p-2 min-w-[max-content] border border-gray-200">
                    <ZoomControl
                        handleZoomIn={handleZoomIn}
                        handleZoomOut={handleZoomOut}
                        zoomLevels={zoomLevels}
                        currentZoomIndex={currentZoomIndex}
                        orientation="horizontal"
                        showLabel={true}
                    />
                </div>
            )}
        </div>
    )
}

export default NavbarZoomControl
